import React from 'react';
import {useFormContext} from 'react-hook-form';
import {FormBlock, FormBlockFieldStandard} from 'api';

interface Block extends FormBlock {
  formBlockable: FormBlockFieldStandard;
}

interface Props {
  block: Block;
}

export default ({block}: Props) => {
  const blockable = block.formBlockable;
  const {
    register,
    formState: {errors = {}},
  } = useFormContext();
  const error: any = errors[block.id];
  const errorFirstName = error?.first_name?.message;
  const errorLastName = error?.last_name?.message;

  return (
    <div className="w-full grid grid-cols-2 gap-4">
      <div className="w-full">
        <div className="flex gap-1 mb-2 items-center">
          <label className="tracking-wide font-bold">
            {blockable.labelLastName || '姓'}
          </label>
          {blockable.isRequired && <span className="text-red-500">*</span>}
        </div>
        <input
          className="form-input block w-full border rounded box-border"
          type="text"
          {...register(`${block.id}.last_name`)}
        />
        {errorLastName && <div className="text-red-500">{errorLastName}</div>}
      </div>
      <div className="w-full">
        <div className="flex gap-1 mb-2 items-center">
          <label className="tracking-wide font-bold">
            {blockable.labelFirstName || '名'}
          </label>
          {blockable.isRequired && <span className="text-red-500">*</span>}
        </div>
        <input
          className="form-input block w-full border rounded box-border"
          type="text"
          {...register(`${block.id}.first_name`)}
        />
        {errorFirstName && <div className="text-red-500">{errorFirstName}</div>}
      </div>
    </div>
  );
};
